import { useAppSelector } from '../../store/storeHooks';
import { StateAction } from '../../types';

const useOurSelectAction = <T = unknown>(action: StateAction<T>) => useAppSelector(action);

export default useOurSelectAction;
